export const formatEntry = (entry: string) => {
  const formatted = entry.replace(/`1`|`2`/g, '');
  const parts = formatted.split('<br>');
  const [word, ...meanings] = parts;

  let html = `<div class="dictionary-entry">`;
  if (word) {
    html += `<h5>${word}</h5>`;
  } else {
    html += `<h5>${meanings[0]}</h5>`;
  }

  meanings.forEach(meaning => {
    if (!meaning.trim()) return; // 跳过空行
    let meaningText = meaning.trim();

    meaningText = meaningText.replace(/[\\/／]/g, '&nbsp;&nbsp;/&nbsp;&nbsp;');
    meaningText = meaningText.replace(/[$$]/g, '<p></p>');
    meaningText = meaningText.replace(/[【】]/g, '&nbsp;');
    meaningText = meaningText.replace(/[，,]/g, ',&nbsp;');
    meaningText = meaningText.replace(/[.]/g, '.&nbsp;');

    html += `<p">${meaningText}</p>`;
  });

  html = html.replace(/`[0-9]`/g, '');
  return html + '</div>';
};

export const formatBasicEntry = (entry: string) => {
  const formatted = entry.replace(/`1`|`2`/g, '');
  const parts = formatted.split('<br>');
  let html = `<div class="dictionary-entry">`;
  html += `<div class="word-reading">
        ${parts.map(part => `<p class="kanji">${part.trim()}</p>`).join('')}
      </div>`;
  html += '</div>';
  return html;
};
